import { memo as Memo } from 'react';

//* HOC
import withUIContext from 'context/consumerHOC/UIConsumer';

//* Components
import CustomLink from 'components/common/CustomLink';
import Container from 'components/common/Container';
import Image from 'components/common/Image';
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';

//* Style
import EventHeroItemStyle from './style';

const EventHeroItem = Memo(({ title, image, slug, date, place, time, text, className, winWidth }) => {
	return (
		<EventHeroItemStyle className={`${className || ''}`}>
			<CustomLink url={`/news-and-events/${slug}`}>
				<Container
					row
					full
					className={`event-hero-section`}>
					<div className={`empty col-1 col-t-12 col-ts-12 col-m-12`} />

					<div className={`event-hero-image col-4 col-t-5 col-ts-12 col-m-12`}>
						<Image
							src={image?.src}
							alt={image?.alt}
						/>
					</div>

					<div className={`event-hero-info col-6 col-t-7 col-ts-12 col-m-12`}>
						<div className={`event-internal`}>
							<div className={`event-content`}>
								<Text
									tag={`h1`}
									className={`h5 minion3-medium primary-color9 uppercase`}
									text={title}
								/>

								<Text
									tag={`p`}
									className={`p p4 notoSans-regular primary-color9 event-hero-text`}
									text={text}
								/>

								<div className={`event-banner`}>
									{winWidth > 1024 ? (
										<>
											<div className={`left-part`}>
												<Icon
													name={`time`}
													className={`p p1`}
												/>

												<div className={`date-time`}>
													<Text
														tag={`p`}
														className={`p p2 minion3-medium primary-color9 uppercase`}
														text={date}
													/>

													<Text
														tag={`p`}
														className={`p p2 minion3-medium primary-color9`}>
														{time[0]}&nbsp;-&nbsp;{time[1]}
													</Text>
												</div>
											</div>
											<div className={`right-part`}>
												<Icon
													name={`location`}
													className={`p p1`}
												/>

												<Text
													tag={`p`}
													className={`p p2 minion3-medium primary-color9 uppercase`}
													text={place}
												/>
											</div>
										</>
									) : winWidth >= 768 && winWidth <= 1024 ? (
										<>
											<div className={`banner-left-part-tablet-version`}>
												<div className={`first-col`}>
													<Icon
														name={`time`}
														className={`p p1`}
													/>

													<div className={`date-time`}>
														<Text
															tag={`p`}
															className={`p p2 minion3-medium primary-color9 uppercase`}
															text={date}
														/>

														<Text
															tag={`p`}
															className={`p p2 minion3-medium primary-color9`}>
															{time[0]}&nbsp;-&nbsp;{time[1]}
														</Text>
													</div>
												</div>

												<div className={`last-col`}>
													<Icon
														name={`location`}
														className={`p p1`}
													/>

													<Text
														tag={`p`}
														className={`p p2 minion3-medium primary-color9 uppercase`}
														text={place}
													/>
												</div>
											</div>

											<div className={`banner-right-part-tablet-version`}>
												<div className={`banner-internal-wrap`}>
													<Text
														tag={`span`}
														className={`event-drag-tablet notoSans-medium uppercase p p3`}
														text={`seeDetails`}
													/>
												</div>
											</div>
										</>
									) : winWidth < 768 ? (
										<>
											<div className={`banner-left-part-mobile-version`}>
												<div className={`first-col`}>
													<div className={`first-col-internal`}>
														<Icon
															name={`time`}
															className={`p p1`}
														/>

														<div className={`date-time`}>
															<Text
																tag={`p`}
																className={`p p2 minion3-medium primary-color9 uppercase`}
																text={date}
															/>

															<Text
																tag={`p`}
																className={`p p2 minion3-medium primary-color9`}>
																{time[0]}&nbsp;-&nbsp;{time[1]}
															</Text>
														</div>
													</div>
												</div>

												<div className={`last-col`}>
													<div className={`banner-internal-wrap`}>
														<Text
															tag={`span`}
															className={`event-drag-mobile notoSans-medium uppercase p p3`}
															text={`seeDetails`}
														/>
													</div>
												</div>
											</div>

											<div className={`banner-right-part-mobile-version`}>
												<Icon
													name={`location`}
													className={`p p1`}
												/>

												<Text
													tag={`p`}
													className={`p p2 minion3-medium primary-color9 uppercase`}
													text={place}
												/>
											</div>
										</>
									) : null}
								</div>
							</div>
						</div>
					</div>

					<div className={`empty col-1 col-t-12 col-ts-12 col-m-12`} />
				</Container>
			</CustomLink>
		</EventHeroItemStyle>
	);
});

export default withUIContext(EventHeroItem, ['winWidth']);
